/* Native Shopify customer form. Reveal the offer only after Shopify confirms success. */
(function () {
  'use strict';

  var STORAGE_KEY = 'freya-welcome-newsletter-v2';
  var REGISTERED_KEY = 'freya-shopify-newsletter-receipt-v1';
  var CONSENT_VERSION = 'newsletter-2026-09-25';
  var QUIET_PERIOD = 7 * 24 * 60 * 60 * 1000;
  var AUTO_DELAY = 5000;

  function init() {
    var header = document.getElementById('site-header');
    var dialog = document.getElementById('welcome-offer');
    if (!header || !dialog) return;

    var bar = document.createElement('div');
    bar.className = 'welcome-bar';
    bar.innerHTML = '<button type="button" class="welcome-trigger" aria-haspopup="dialog" aria-controls="welcome-offer">' +
      '<span>İlk alışverişinize <strong>%10 indirim</strong></span><span class="welcome-bar-link">Keşfet <span aria-hidden="true">↗</span></span></button>';
    header.prepend(bar);
    var signupStatus = document.createElement('p');
    signupStatus.className = 'welcome-signup-status';
    signupStatus.setAttribute('role', 'status');
    signupStatus.hidden = true;
    bar.append(signupStatus);

    var trigger = bar.querySelector('button');
    var closeButton = dialog.querySelector('.welcome-close');
    var copyButton = dialog.querySelector('.welcome-copy-code');
    var feedback = dialog.querySelector('.welcome-feedback');
    var form = dialog.querySelector('#welcome-signup');
    var emailInput = dialog.querySelector('#welcome-email');
    var errorMessage = dialog.querySelector('#welcome-error');
    var submitButton = dialog.querySelector('.welcome-submit');
    var confirmed = document.getElementById('freya-newsletter-success');
    var code = ''; 
    var submitting = false;
    var previousFocus = null;
    var autoTimer = 0;
    var signupTimer = 0;
    var hasShown = false;
    var started = Date.now();

    function showReward(receipt) {
      code = receipt.code;
      form.hidden = true;
      dialog.querySelector('.welcome-reward').hidden = false;
      dialog.querySelector('#welcome-code-value').textContent = code;
      dialog.querySelector('#welcome-description').textContent = 'E-posta aboneliğinizi onayladıktan sonra kodunuz ilk siparişinizde geçerli olur. Ödeme adımında kayıt olduğunuz e-posta adresini kullanın.';
      try { sessionStorage.setItem(REGISTERED_KEY, JSON.stringify({code:code})); } catch (_) {}
    }

    if (confirmed && confirmed.dataset.code) showReward({code:confirmed.dataset.code});
    try {
      var receipt = JSON.parse(sessionStorage.getItem(REGISTERED_KEY));
      if (receipt && typeof receipt.code === 'string' && /^[A-Z0-9_-]{3,40}$/.test(receipt.code)) showReward(receipt);
    } catch (_) {}

    function prepareSignup(event) {
      emailInput.value = emailInput.value.trim();
      errorMessage.textContent = '';
      if (!form.checkValidity()) {
        event.preventDefault();
        form.reportValidity();
        return;
      }
      if (submitting) return;
      submitting = true;
      signupStatus.textContent = 'Kaydınız gönderiliyor. Doğrulama istenirse lütfen tamamlayın.';
      signupStatus.hidden = false;
      // Keep the native form rendered while Shopify completes its CAPTCHA flow.
      // A non-modal dialog lets Shopify's challenge receive focus above it.
      if (dialog.open && dialog.matches(':modal')) {
        dialog.close();
        dialog.classList.add('welcome-verifying');
        dialog.show();
      }
      clearTimeout(signupTimer);
      signupTimer = setTimeout(function () {
        submitting = false;
        signupStatus.textContent = 'Kayıt henüz tamamlanmadı. Açılan doğrulamayı tamamlayın veya formdan tekrar deneyin.';
        errorMessage.textContent = 'Kayıt henüz tamamlanmadı. E-posta adresiniz korunuyor; doğrulamayı tamamlayıp tekrar deneyebilirsiniz.';
      }, 25000);
    }
    form.addEventListener('submit', prepareSignup, true);
    submitButton.addEventListener('click', prepareSignup, true);

    function hasSeen() {
      if (hasShown) return true;
      try {
        if (sessionStorage.getItem(STORAGE_KEY)) return true;
        var lastSeen = Number(localStorage.getItem(STORAGE_KEY));
        return lastSeen > 0 && Date.now() - lastSeen < QUIET_PERIOD;
      } catch (_) { return false; }
    }

    function remember() {
      hasShown = true;
      try { sessionStorage.setItem(STORAGE_KEY, '1'); } catch (_) {}
      try { localStorage.setItem(STORAGE_KEY, String(Date.now())); } catch (_) {}
    }

    function anotherDialogIsOpen() {
      return !!document.querySelector('dialog[open], #pmodal:not(.hidden), .mobile-nav:not([hidden])');
    }

    function open() {
      if (dialog.open || anotherDialogIsOpen()) return;
      clearTimeout(autoTimer);
      previousFocus = document.activeElement;
      feedback.textContent = '';
      signupStatus.hidden = true;
      copyButton.querySelector('span').textContent = 'Kopyala';
      dialog.showModal();
      dialog.scrollTop = 0;
      document.documentElement.classList.add('welcome-open');
      closeButton.focus({preventScroll:true});
      remember();
    }

    function finishClose() {
      // Native close events are queued; an immediate reopen must retain focus.
      if (dialog.open) return;
      document.documentElement.classList.remove('welcome-open');
      if (previousFocus && previousFocus.isConnected && previousFocus !== document.body) previousFocus.focus({preventScroll:true});
      else trigger.focus({preventScroll:true});
    }

    function close() {
      if (!dialog.open) return;
      clearTimeout(signupTimer);
      submitting = false;
      dialog.classList.remove('welcome-verifying');
      dialog.close();
      finishClose();
    }

    trigger.addEventListener('click', open);
    closeButton.addEventListener('click', close);
    dialog.querySelector('.welcome-later').addEventListener('click', close);
    dialog.querySelector('.welcome-shop').addEventListener('click', close);
    dialog.addEventListener('cancel', function (event) { event.preventDefault(); close(); });
    dialog.addEventListener('close', finishClose);
    dialog.addEventListener('keydown', function (event) {
      if (event.key !== 'Tab' || dialog.classList.contains('welcome-verifying')) return;
      var controls = Array.from(dialog.querySelectorAll('button:not([disabled]), a[href], input:not([disabled])')).filter(function (element) { return element.tabIndex !== -1 && !element.closest('[hidden], .welcome-honeypot'); });
      var first = controls[0], last = controls[controls.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });
    var backdropDown = false;
    function outside(event) {
      var rect = dialog.getBoundingClientRect();
      return event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom);
    }
    dialog.addEventListener('pointerdown', function (event) { backdropDown = outside(event); });
    dialog.addEventListener('click', function (event) { if (backdropDown && outside(event)) close(); backdropDown = false; });

    copyButton.addEventListener('click', async function () {
      try {
        if (!navigator.clipboard || !window.isSecureContext) throw new Error('Clipboard unavailable');
        if (!code) return;
        await navigator.clipboard.writeText(code);
        copyButton.querySelector('span').textContent = 'Kopyalandı';
        feedback.textContent = code + ' kodu kopyalandı.';
      } catch (_) {
        feedback.textContent = 'Kodu seçip kopyalayabilirsiniz: ' + code;
        var selection = window.getSelection();
        var range = document.createRange();
        range.selectNodeContents(dialog.querySelector('#welcome-code-value'));
        selection.removeAllRanges();
        selection.addRange(range);
      }
    });

    function maybeOpen() {
      clearTimeout(autoTimer);
      if (hasSeen()) return;
      var editing = document.activeElement && document.activeElement.matches('input, textarea, select, [contenteditable="true"]');
      if (document.hidden || anotherDialogIsOpen() || editing || Date.now() - started < AUTO_DELAY) {
        autoTimer = setTimeout(maybeOpen, 1500);
        return;
      }
      open();
    }

    if (confirmed || document.getElementById('freya-newsletter-server-error')) setTimeout(open, 100);
    // Keep recipes and reading pages uninterrupted; the bar remains available.
    if (['anasayfa', 'urunler'].includes(document.body.dataset.page) && !hasSeen()) {
      autoTimer = setTimeout(maybeOpen, AUTO_DELAY);
    }
    window.addEventListener('pagehide', function () { clearTimeout(autoTimer); clearTimeout(signupTimer); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
